import {h} from 'hastscript'

import {feedbackUrl} from '../../ErrorFallback'
import {HastElementWidget} from './hast-element'
import styles from './render-error.module.css'

export class RenderErrorWidget extends HastElementWidget {
  constructor() {
    super(
      h(
        'p',
        {
          role: 'alert',
          className: styles.errorMessage,
        },
        [
          'An unexpected error occurred while building the Markdown preview. The editor may continue to function, but some features will not work as expected. If the issue persists, please ',
          h('a', {href: feedbackUrl}, 'contact support'),
          '.',
        ],
      ),
    )
  }

  override ignoreEvent(): boolean {
    return true
  }
}
